class CollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.grid = document.querySelector('.collection-grid');
    
    if (!this.button || !this.grid) return;
    
    if (this.dataset.scroll === 'true') {
      this.initIntersectionObserver();
    } else {
      this.button.addEventListener('click', this.loadMore.bind(this));
    }
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px 400px 0px', // Preload when user is 400px away
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.button.classList.contains('loading')) {
          this.loadMore();
        }
      });
    }, options);

    this.observer.observe(this.button);
  }

  async loadMore() {
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');
    
    const nextUrl = this.button.dataset.href;
    
    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(text, 'text/html');
      
      const newProducts = html.querySelectorAll('.product-card, product-card');
      const nextButton = html.querySelector('.load-more-btn');
      
      // Append new products
      newProducts.forEach(product => {
        this.grid.appendChild(product); 
      });

      // Update button for next page
      if (nextButton && nextButton.dataset.href) {
        this.button.dataset.href = nextButton.dataset.href;
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');
      } else {
        // No more pages
        if (this.observer) this.observer.disconnect();
        this.style.display = 'none';
      }

    } catch (error) {
      console.error('Error loading products:', error);
      this.button.removeAttribute('disabled');
      this.button.classList.remove('loading');
    }
  }
}

if (!customElements.get('collection-load-more')) {
  customElements.define('collection-load-more', CollectionLoadMore);
}

// Collection Description Read More
class CollectionDescription extends HTMLElement {
  constructor() {
    super();
    this._hasConnected = false;
    this._boundToggle = this.toggle.bind(this);
  }

  connectedCallback() {
    if (this._hasConnected) return;
    this._hasConnected = true;

    this.readMoreBtn = this.querySelector('[data-read-more]');
    if (!this.readMoreBtn) return;
    
    this.shortDescription = this.querySelector('[data-description-short]');
    this.fullDescription = this.querySelector('[data-description-full]');
    this.readMoreText = this.readMoreBtn.querySelector('[data-read-more-text]');
    
    this.readMoreBtn.addEventListener('click', this._boundToggle);
  }
  
  toggle() {
    const isExpanded = this.readMoreBtn.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      this.shortDescription.style.display = '';
      this.fullDescription.style.display = 'none';
      this.readMoreText.textContent = 'Read more';
      this.readMoreBtn.setAttribute('aria-expanded', 'false');
    } else {
      this.shortDescription.style.display = 'none';
      this.fullDescription.style.display = 'block';
      this.readMoreText.textContent = 'Read less';
      this.readMoreBtn.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription);
}
